import Job from "./job";
import Customer from "./customer";
import Pump from "./pump";
import SiteContact from "./site_contact";
import CodeJobType from "./code_job_type";
import Supplier from "./supplier";
import JobFile from "./job_file";
import CodeFileType from "./code_file_type";
import JobNote from "./job_note";
import Supervisor from "./supervisor";
import Employee from "./employee";
import JobAssignment from "./job_assignment";
import CodeArea from "./code_area";

import { default as PermissionSchema } from "../../vue-ocom/grouppermissions/schema/index.js";

export default {
  Job,
  Customer,
  Pump,
  SiteContact,
  CodeJobType,
  Supplier,
  JobFile,
  CodeFileType,
  JobNote,
  Supervisor,
  Employee,
  JobAssignment,
  CodeArea,
  ...PermissionSchema /* For Schema */,
};
